/** Couleurs des chapitres (ordre fixe), validées pour le fond #2A2A2A (dataviz : bande L, CVD, contraste).
 *  calcul et pourcentages : chapitres de l'épreuve anticipée de Première ; nombres à algo : chapitres du brevet. */
export const CHAPITRE_COLORS: Record<string, string> = {
  probabilites: '#B08A1A',
  geometrie: '#2AA396',
  suites: '#5B8DEF',
  fonctions: '#D1709A',
  calcul: '#9B86D9',
  pourcentages: '#C9693C',
  // brevet
  nombres: '#9B86D9',
  grandeurs: '#C9693C',
  stats: '#B08A1A',
  algo: '#7FA650',
};
